<p-toast></p-toast>
<p-toast key="global-error" position="bottom-right"></p-toast>
<p-confirmDialog [style]="{ width: '420px' }"></p-confirmDialog>

<router-outlet></router-outlet>
